import {
  Card,
  Grid,
  TextField,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import AppService from "../../../../Configurations/Appservice";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { useLocation, useNavigate } from "react-router-dom";

const initialValues = {
  name: "",
  phone: "",
  email: "",
};

const validationSchema = object({
  name: string().required("Name is Mandatory"),
  phone: string().required("Phone Number is Mandatory"),
  email: string().email().required("Email is Mandatory"),
});

const EditAgentUser = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const formikRef = useRef();
  const naviagte = useNavigate();

  useEffect(() => {
    dispatch(updateScreenTitle("Edit Agent User"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    dispatch(showLoader());
    const userId = location.state?.userId;
    let params = {
      userId,
    };
    if (!userId) {
      dispatch(dismissLoader());
      return;
    }

    AppService.get("v1/user/details", { params })
      .then((response) => {
        formikRef.current.setFieldValue("name", response.name);
        formikRef.current.setFieldValue("phone", response.phoneNumber);
        formikRef.current.setFieldValue("email", response.emailId);
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  const _submitHandler = (values, { resetForm }) => {
    dispatch(showLoader());
    const payload = {
      id: location.state?.userId,
      name: values.name,
      phone: values.phone,
      email: values.email,
    };
    AppService.put("v1/user", payload)
      .then((response) => {
        resetForm();
        dispatch(showSuccessMessage("User updated Successfully"));
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
        naviagte(-1);
      });
  };

  return (
    <WDBox py={1}>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_submitHandler}
          validationSchema={validationSchema}
          innerRef={formikRef}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>Edit User</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <WDBox>
                      <Field
                        name="name"
                        label="Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.name) && Boolean(touched.name)}
                        helperText={Boolean(touched.name) && errors.name}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <WDBox>
                      <Field
                        name="phone"
                        label="Phone Number"
                        fullWidth
                        type="tel"
                        as={TextField}
                        error={Boolean(errors.phone) && Boolean(touched.phone)}
                        helperText={Boolean(touched.phone) && errors.phone}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <WDBox>
                      <Field
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                      />
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default EditAgentUser;
